import React, { Component } from 'react';
import Footer from "../components/Footer.js"
import NavBar from "../components/NavBar.js"

import '../css/main.css';

class AboutUsPage extends Component {

  constructor(props) {
    super(props);
    this.chaptersRef = [];
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
    );

    this.chaptersRef.forEach(ref => {
      if (ref) this.observer.observe(ref);
    });

    if (this.chaptersRef[0]) {
      setTimeout(() => this.chaptersRef[0].classList.add('visible'), 100);
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    return (
        <div id="body">
          <NavBar />

          <div className="about_section" style={{paddingTop: '80px'}}>
            {/* Chapter 1 — Origin */}
            <div
              className="story_chapter about_chapter_wide reveal"
              ref={el => this.chaptersRef[0] = el}
            >
              <span className="story_chapter_number">01</span>
              <div className="story_chapter_content">
                <p className="story_chapter_label">Origin</p>
                <h2 className="story_chapter_title">起源</h2>
                <p className="story_chapter_text">
                  DoDay，是一家什麼樣的甜品店？
                  早上的豆日子充斥著活力與希望，也許你會遇見在市場買菜的阿姨、偷偷翹課的大學生，或是對這裡感到好奇的日本遊客。這時來碗冰涼的豆花，消解暑氣的同時也能帶給味蕾單純的愉悅。
                </p>
              </div>
              <img
                className="story_chapter_img"
                src={process.env.PUBLIC_URL + "/image/girl.png"}
                alt="豆日子起源"
              />
            </div>

            {/* Chapter 2 — Inheritance (DARK) */}
            <div
              className="story_chapter about_chapter_dark reveal"
              ref={el => this.chaptersRef[1] = el}
              style={{transitionDelay: '0.1s'}}
            >
              <span className="story_chapter_number">02</span>
              <div className="story_chapter_content">
                <p className="story_chapter_label">Inheritance</p>
                <h2 className="story_chapter_title">傳承</h2>
                <p className="story_chapter_text">
                  晚上的豆日子，則搖身一變成為夜晚中溫暖的存在。不管是辛勤加班的上班族，還是挑燈夜戰的學生們，我們都會獻上一碗溫熱的豆花，讓他們重新蓄滿面對明天的動力。
                  每個人都懷有自己的人生際遇，而每天只需要一碗豆花的時間，你可以去傾聽屬於他們和豆日子的故事。
                </p>
              </div>
              <img
                className="story_chapter_img"
                src={process.env.PUBLIC_URL + "/image/douhua.JPG"}
                alt="豆日子傳承"
              />
            </div>

            {/* Chapter 3 — Innovation */}
            <div
              className="story_chapter reveal"
              ref={el => this.chaptersRef[2] = el}
              style={{transitionDelay: '0.1s'}}
            >
              <span className="story_chapter_number">03</span>
              <div className="story_chapter_content">
                <p className="story_chapter_label">Innovation</p>
                <h2 className="story_chapter_title">國際級豆花甜品店</h2>
                <p className="story_chapter_text">
                  一甲子傳統老店技術結合科技創新團隊。豆日子期許將台灣傳統美味的豆花等甜品推向全世界。年輕有活力的經營團隊，用更寬大的國際視角來經營和規劃。在設計上找來國際級設計獲奬的團隊，而在豆花製作上則與一甲子傳統老店技術合作，結合自動化的技術，堅持健康安心的理念。
                </p>
              </div>
              <img
                className="story_chapter_img"
                src={process.env.PUBLIC_URL + "/image/innovation.png"}
                alt="豆日子創新"
              />
            </div>

            {/* Chapter 4 — Future */}
            <div
              className="story_chapter about_future_bg reveal"
              ref={el => this.chaptersRef[3] = el}
              style={{transitionDelay: '0.1s'}}
            >
              <span className="story_chapter_number">04</span>
              <div className="story_chapter_content">
                <p className="story_chapter_label">Future</p>
                <h2 className="story_chapter_title">未來</h2>
                <p className="about_future_text">
                  「選對了，就愛上了」
                </p>
                <p className="story_chapter_text" style={{marginTop: '24px'}}>
                  傳統美食，讓它奔向世界吧！這是一間明亮有活力的國際級豆花甜品店，也是一間可以在每一天帶給顧客溫暖、充滿你我故事的店。致力於打造一間傳統與科技結合的美味甜品店，讓每一天都是豆日子。
                </p>
              </div>
              <img
                className="story_chapter_img"
                src={process.env.PUBLIC_URL + "/image/about_doday.png"}
                alt="豆日子未來"
              />
            </div>
          </div>

          {/* Press logos strip */}
          <div className="about_press_strip">
            <p className="about_press_label">As Featured In</p>
            <div className="about_press_logos">
              <span>Harper's Bazaar</span>
              <span>Marie Claire</span>
              <span>China Times</span>
              <span>UP Media</span>
              <span>WalkerLand</span>
            </div>
          </div>

          {/* Ending CTA */}
          <div className="about_ending_cta">
            <h2 className="about_ending_title">嚐一口豆日子</h2>
            <a href="/menu" className="hero_cta hero_cta_primary" style={{ animation: 'none', opacity: 1 }}>
              查看菜單
            </a>
          </div>

          <Footer />
        </div>
    );
  }
}

export default AboutUsPage;
